import { cloudFunction } from 'services/parse';

export const fetchCronJobs = async () => {
  const response = await cloudFunction('fetchJobs', {});
  return response;
};

export const fetchCronJobDetails = async (id: string) => {
  const response = await cloudFunction('fetchJobDetails', { id });
  return response.toJSON();
};

export const getJobServerInstances = () => {
  return cloudFunction('getJobServerInstances', {});
};

export const toggleJobActiveStatus = (id: string) => {
  return cloudFunction('toggleJobActiveStatus', { id });
};

export const setJobServerInstance = (id: string, jobServerInstance: string) => {
  return cloudFunction('setJobServerInstance', { id, jobServerInstance });
};

export const setJobCronExpression = (id: string, cronExpression: string) => {
  return cloudFunction('setJobCronExpression', { id, cronExpression });
};

export const setJobParams = (id: string, params: {}) => {
  return cloudFunction('setJobParams', { id, params });
};